import { Typography, Box } from "@mui/material";

const HomeSection = () => (
    <Box
        id="home"
        sx={{
            height: { xs: "35vh", md: "80vh" },
            backgroundImage: "url('/img/BG1.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: { xs: "flex" },
            alignItems: "center",
        }}
    >
        <Typography
            variant="h3"
            sx={{ fontSize: { xs: "45px", md: "75px" } }}
            style={{
                color: "white",
                marginLeft: "10%",
                textShadow: "2px 2px 4px rgba(0,0,0,0.7)"
            }}
        >
            YOU ENVISION,<br />
            WE BUILD<br />
            FUTURES.
        </Typography>
    </Box >
);

export default HomeSection;